import React, { forwardRef, useState } from 'react';
import clsx from 'clsx';
import { Element, Icon } from '../../atoms';
import styles from './star-rating.styles';

// https://nextjs.org/docs/messages/css-npm

/** @type {import(".").StarRatingType} */
const StarRating = forwardRef(({ children, className, color, isInteractive, onClick, onChange, total = 5, value = 0, typography, ...props }, ref) => {
  const [hoverValue, setHoverValue] = useState(value);
  const currentValue = isInteractive ? hoverValue || value : value;

  const interactiveHandlers = {
    onMouseMove: ({ target }) => {
      if (target.dataset?.rating) {
        setHoverValue(parseInt(target.dataset.rating, 10));
      }
    },
    onMouseLeave: () => {
      setHoverValue(null);
    },
  };

  const handleOnClick = (event) => {
    onClick?.(event);

    if (event.target.dataset?.rating) {
      event.target.value = parseInt(event.target.dataset.rating, 10);
      onChange?.(event);
    }
  };

  return (
    <Element
      ref={ref}
      as="div"
      className={clsx(styles.root, className)}
      isInteractive={isInteractive}
      onClick={handleOnClick}
      {...(isInteractive && interactiveHandlers)}
      {...props}
    >
      <span className={styles.iconsContainer}>
        {Array.from({ length: total }, (_, i) => {
          let variant = 'empty';
          if (currentValue >= i + 0.75) {
            variant = 'fill';
          }
          if (currentValue - 0.25 >= i && currentValue < i + 0.75) {
            variant = 'half';
          }

          return <Icon key={i} className={styles.icon} name={`star-${variant}`} data-rating={i + 1} />;
        })}
      </span>
      <Element as="span" className={styles.label} typography={typography}>
        {children}
      </Element>
    </Element>
  );
});

export default StarRating;
